import { render, staticRenderFns } from "./todayPlayerPointSpecial3.vue?vue&type=template&id=92631ee6&scoped=true&"
import script from "./todayPlayerPointSpecial3.vue?vue&type=script&lang=js&"
export * from "./todayPlayerPointSpecial3.vue?vue&type=script&lang=js&"
import style0 from "./todayPlayerPointSpecial3.vue?vue&type=style&index=0&id=92631ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92631ee6",
  null
  
)

export default component.exports